// The API answers a ui-avatars.com picture for a horse or a user without photo
// (api.alogo.io app/Traits/Gravatar.php): that is no photo, the app draws the initials itself.
const GENERATED_AVATAR = /^https?:\/\/ui-avatars\.com\//i

export const photoOf = (url) => (typeof url === 'string' && url.trim() && !GENERATED_AVATAR.test(url) ? url : null)

// The first letter of the first two words: « Heat Wave » → « HW », « Bella » → « B ».
export const initialsOf = (name) =>
    String(name ?? '')
        .split(/\s+/)
        .map((word) => word.match(/[\p{L}\p{N}]/u)?.[0])
        .filter(Boolean)
        .slice(0, 2)
        .join('')
        .toLocaleUpperCase()
